import { orderBy } from 'lodash'
import { ROLES } from '@/config'

/* Returns the access level corresponding to a given integer level */
export const getRole = (level: number) => {
  const roles = orderBy(Object.values(ROLES), [l => l.value], ['desc'])
  return roles.find(role => level >= role.value)
}
